import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { ProductStore, SortFilter } from 'src/app/stores/product.store';

@Component({
  selector: 'app-sort-by',
  templateUrl: './sort-by.component.html',
  styleUrls: ['./sort-by.component.scss'],
})
export class SortByComponent implements OnInit {
  @Output() onFilterChanged = new EventEmitter();
  sortFilter = SortFilter;
  params: {
    product_sort_status: number;
  };

  constructor(
    private modalCtrl: ModalController,
    public productStore: ProductStore,
    public platform: Platform,
    private auth: AuthenticationStore
  ) {
    this.auth.clearAll.subscribe((data) => {
      this.params = {
        product_sort_status: null,
      };
      productStore.sortFilter = null;
      this.auth.isClear.next('clear');
    });
  }

  modaldismiss() {
    this.params = {
      product_sort_status: this.productStore.sortFilter,
    };
    this.productStore.getProducts(this.params);
    this.modalCtrl.dismiss(this.params);
  }

  changeFilter(result) {
    this.params = {
      product_sort_status: result,
    };
    this.onFilterChanged.emit(this.params);
    this.auth.isClear.next('setClear');
  }
  ngOnInit() {}
}
